import { render, staticRenderFns } from "./DiligenciarFD.vue?vue&type=template&id=28c078dd&scoped=true"
import script from "./DiligenciarFD.vue?vue&type=script&lang=js"
export * from "./DiligenciarFD.vue?vue&type=script&lang=js"
import style0 from "./DiligenciarFD.vue?vue&type=style&index=0&id=28c078dd&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28c078dd",
  null
  
)

export default component.exports